export default __webpack_public_path__ + "static/image-70-1ad111aebd913a897a04ccb8e52ca9cc.jpg";